// extracted by mini-css-extract-plugin
module.exports = {"root":"MainSingleFormContent_root__bZI7Y"};